import { render, staticRenderFns } from "./firstPage.vue?vue&type=template&id=dd5e1f72&scoped=true"
import script from "./firstPage.vue?vue&type=script&lang=js"
export * from "./firstPage.vue?vue&type=script&lang=js"
import style0 from "./firstPage.vue?vue&type=style&index=0&id=dd5e1f72&prod&scoped=true&lang=css"
import style1 from "./firstPage.vue?vue&type=style&index=1&id=dd5e1f72&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dd5e1f72",
  null
  
)

export default component.exports